module.exports = __webpack_public_path__ + "img/DK17625012.11c49fba.png";